import {OperationErrorType, StoreAction} from "orpyx-web-common";
import {IPatientStatusType} from "admins-dashboard/http-clients/index";

export enum PatientStatusTypesActions {
    INITIALIZE = 'PATIENT_STATUS_TYPES: INITIALIZE',
    INITIALIZE_SUCCESSFULLY = 'PATIENT_STATUS_TYPES: INITIALIZE_SUCCESSFULLY',
    INITIALIZE_FAILED = 'PATIENT_STATUS_TYPES: INITIALIZE_FAILED',
}

export const PATIENT_STATUS_TYPES_INITIALIZE = (): StoreAction<PatientStatusTypesActions> => ({
    type: PatientStatusTypesActions.INITIALIZE
});

export const PATIENT_STATUS_TYPES_INITIALIZE_SUCCESSFULLY = (statusTypes: IPatientStatusType[]): StoreAction<PatientStatusTypesActions> => ({
    type: PatientStatusTypesActions.INITIALIZE_SUCCESSFULLY, payload: statusTypes
});

export const PATIENT_STATUS_TYPES_INITIALIZE_FAILED = (error: OperationErrorType): StoreAction<PatientStatusTypesActions> => ({
    type: PatientStatusTypesActions.INITIALIZE_FAILED, payload: error
});
